import { lsTest } from '@hokify/shared-components-nuxt3/lib/helpers/localstorage';

export const saveCountryPreference = (country: 'at' | 'de') => {
	if (lsTest()) {
		localStorage.setItem('country-preference', JSON.stringify(country));
	}
};
